import { render, staticRenderFns } from "./SkuPicker.vue?vue&type=template&id=d80d7cd6&scoped=true&"
import script from "./SkuPicker.vue?vue&type=script&setup=true&lang=js&"
export * from "./SkuPicker.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SkuPicker.vue?vue&type=style&index=0&id=d80d7cd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80d7cd6",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QDialog});
